import { render, staticRenderFns } from "./UserProfileForm.vue?vue&type=template&id=988b02c0"
import script from "./UserProfileForm.vue?vue&type=script&lang=js"
export * from "./UserProfileForm.vue?vue&type=script&lang=js"
import style0 from "./UserProfileForm.vue?vue&type=style&index=0&id=988b02c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports